<template>
  <div id="contenedor-contrato-garantias-main">
    <tool-bar
      v-if="!$apollo.loading"
      class="my-3"
      v-on:nuevaGarantia="registrarNuevaGarantia"
    >
    </tool-bar>
    <!-- Loader -->
    <v-skeleton-loader
      v-if="$apollo.loading"
      type="table-heading, table-thead, table-tbody"
    >
    </v-skeleton-loader>
    <listado
      v-if="!$apollo.loading"
      :listadoGarantias="getContratoGarantias">
    </listado>
    <!-- Ventana Registrar Nueva Garantia -->
    <v-dialog
      v-model="mostrarVentanaRegistrarNuevaGarantia"
      width="600"
      persistent>
      <nueva-garantia
        v-if="mostrarVentanaRegistrarNuevaGarantia"
        :idContrato="idContrato"
        v-on:cerrar="cerrarVentana"
      >
      </nueva-garantia>
    </v-dialog>
    <!-- Ventana Editar Garantia -->
    <v-dialog
      v-if="estaGarantia"
      v-model="mostrarVentanaEditarGarantia"
      width="500">
        <editar-garantia
          :garantiaEditar="estaGarantia"
          v-on:cerrar="cerrarVentana"
        />
    </v-dialog>
    <!-- Ventana Eliminar Garantia -->
    <v-dialog
      v-if="estaGarantia"
      v-model="mostrarVentanaEliminarGarantia"
      :width="!$vuetify.breakpoint.mobile ? '450' : '90%'">
        <eliminar-garantia
          :garantiaEliminar="estaGarantia"
          v-on:cerrar="cerrarVentana"
        />
    </v-dialog>
  </div>
</template>

<script>

import CONTRATO_GARANTIAS from '@/graphql/querys/administracion/contratos/garantias/contratoGarantias.gql';
import ToolBar from './ToolBar.vue';
import NuevaGarantia from '@/components/administracion/contratos/contrato/garantias/Nueva.vue';
import EditarGarantia from '@/components/administracion/contratos/contrato/garantias/Editar.vue';
import EliminarGarantia from '@/components/administracion/contratos/contrato/garantias/Eliminar.vue';
import Listado from './listado/Main.vue';
import eventBus from '@/helpers/eventBus';

export default {
  name: 'ContratoGarantiasMain',
  components: {
    ToolBar,
    Listado,
    NuevaGarantia,
    EditarGarantia,
    EliminarGarantia,
  },
  data() {
    return {
      idContrato: this.$route.params.idContrato,
      mostrarVentanaRegistrarNuevaGarantia: false,
      mostrarVentanaEditarGarantia: false,
      mostrarVentanaEliminarGarantia: false,
      estaGarantia: null,
    };
  },
  methods: {
    registrarNuevaGarantia() {
      this.mostrarVentanaRegistrarNuevaGarantia = true;
    },
    cerrarVentana() {
      this.mostrarVentanaRegistrarNuevaGarantia = false;
      this.mostrarVentanaEditarGarantia = false;
      this.mostrarVentanaEliminarGarantia = false;
      this.estaGarantia = null;
    },
  },
  apollo: {
    contratoGarantias: {
      query: CONTRATO_GARANTIAS,
      variables() {
        return {
          idContrato: this.$route.params.idContrato,
        };
      },
    },

  },
  computed: {
    getContratoGarantias() {
      if (!this.contratoGarantias) return [];
      return this.contratoGarantias
        .slice()
        .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
    },
  },
  mounted() {
    eventBus.$on('editar-garantia-contrato', (garantiaContrato) => {
      this.estaGarantia = garantiaContrato;
      this.mostrarVentanaEditarGarantia = true;
    });
    eventBus.$on('eliminar-garantia-contrato', (garantiaContrato) => {
      this.estaGarantia = garantiaContrato;
      this.mostrarVentanaEliminarGarantia = true;
    });
  },
};
</script>

<style lang="scss">
</style>
